import { FullWidthSpace } from "melco-ui";
import { FontCollectionsReferencesList } from "../../references/FontCollectionsReferencesList";
import { useTranslation } from "react-i18next";
import { ReferencesListAlert } from "../../references/ReferencesListAlert";
import { useFontReferences } from "../../../hooks/libraries/fonts/useFontReferences";

type FontReferencesListProps = {
  fontId: string;
};

export const FontReferencesList: React.FC<FontReferencesListProps> = ({
  fontId,
}) => {
  const { t } = useTranslation();

  const { data: fontReferences } = useFontReferences(fontId);

  return (
    <FullWidthSpace direction="vertical" size="large">
      <ReferencesListAlert message={t("fonts.actions.references.warning")} />
      <FontCollectionsReferencesList
        fontCollectionReferences={
          fontReferences?.alphabet_collection_list ?? undefined
        }
      />
    </FullWidthSpace>
  );
};
